import { CURRENCY_OPTIONS, DEFAULT_CURRENCY_CODE } from '@/utils/constants'
import { BASE_CURRENCIES, Currencies } from '@/utils/constants/package'

/**
 * Determines whether the given currency is one of the base currencies
 * (currencies that are charged directly without conversion).
 */
export function isBaseCurrency(currency: Currencies): boolean {
  const baseCurrencies = Object.values(BASE_CURRENCIES) as Currencies[]
  return baseCurrencies.includes(currency)
}

/**
 * Converts a USD base amount into the given currency and formats it with the
 * currency's locale. Falls back to USD when the code is not recognised.
 */
export function formatCurrency(amountInUsd: number, code: string): string {
  const currency = CURRENCY_OPTIONS.find((option) => option.code === code) ?? CURRENCY_OPTIONS[0]
  const value = amountInUsd * currency.rate

  return new Intl.NumberFormat(currency.locale, {
    style: 'currency',
    currency: currency.code || DEFAULT_CURRENCY_CODE,
    maximumFractionDigits: value % 1 === 0 ? 0 : 2,
  }).format(value)
}

/**
 * Formats a price difference with an explicit sign — "+$42", "-$22", or "$0".
 */
export function formatSignedCurrency(amountInUsd: number, code: string): string {
  const formatted = formatCurrency(Math.abs(amountInUsd), code)
  if (amountInUsd > 0) return `+${formatted}`
  if (amountInUsd < 0) return `-${formatted}`
  return formatted
}
